import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Heart, RotateCcw } from "lucide-react";

const LIMIT_CONFIG = {
  like: {
    icon: "/icons/photo_overlay_button_4.svg",
    title: (current, max) => `Лайки закончились (${current}/${max})`,
    buttonText: "Хочу оценивать без ограничений",
    defaultMax: 70,
  },
  superlike: {
    icon: "/icons/photo_overlay_button_2.svg",
    title: (current, max) => `Супер-лайки закончились (${current}/${max})`,
    buttonText: "Хочу 5 супер-лайков в день",
    defaultMax: 1,
  },
  rewind: {
    icon: "/icons/photo_overlay_button_3.svg",
    title: (current, max) => `Возврат анкеты закончились (${current}/${max})`,
    buttonText: "Хочу 5 возвратов в неделю",
    defaultMax: 1,
  },
};

function DayLimit({
  type = "like",
  currentCount,
  maxCount,
  resetTime,
  onClose,
}) {
  const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState("");

  const config = LIMIT_CONFIG[type] || LIMIT_CONFIG.like;
  const current = currentCount ?? config.defaultMax;
  const max = maxCount ?? config.defaultMax;

  useEffect(() => {
    // Вычисляем время до полуночи или используем переданное время
    const calculateTimeLeft = () => {
      let targetTime;

      if (resetTime) {
        targetTime = new Date(resetTime);
      } else {
        // По умолчанию - до следующей полуночи
        const now = new Date();
        targetTime = new Date(now);
        targetTime.setHours(24, 0, 0, 0);
      }

      const now = new Date();
      const diff = targetTime - now;

      if (diff <= 0) {
        return "скоро";
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      return `${hours} ч ${minutes} мин`;
    };

    setTimeLeft(calculateTimeLeft());

    // Обновляем каждую минуту
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 60000);

    return () => clearInterval(interval);
  }, [resetTime]);

  const handleUpgradeClick = () => {
    if (onClose) onClose();
    navigate("/premium");
  };

  return (
    <div
      className="w-[100%] max-h-[500px] bg-[#043939] flex flex-col justify-start items-center bottom-0 z-20 text-white pb-8 pt-3 relative"
      style={{ borderRadius: "32px 32px 0 0" }}
    >
      {/* Кнопка закрытия */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-white/20 transition-colors z-50"
        aria-label="Закрыть"
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 1L1 13M1 1L13 13"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* Индикатор сверху для свайпа */}
      <div className="bg-[#0b6666] w-[80px] h-[6px] rounded-[20px] mb-8"></div>

      {/* Иконка с белым кругом */}
      <div className="w-[80px] h-[80px] rounded-full border-2 border-white flex items-center justify-center">
        {type === "superlike" ? (
          <div className="flex flex-col items-center">
            <Heart className="w-[24px] h-[24px] text-white fill-white" />
            <span className="text-[10px] font-medium text-white mt-1">
              СУПЕР
            </span>
          </div>
        ) : type === "like" ? (
          <Heart className="w-[32px] h-[32px] text-white fill-white" />
        ) : type === "rewind" ? (
          <RotateCcw className="w-[32px] h-[32px] text-white" />
        ) : (
          <img
            src={config.icon}
            alt="Достигнут дневной лимит"
            className="w-[40px] h-[40px]"
          />
        )}
      </div>

      {/* Заголовок */}
      <h1 className="text-[22px] font-semibold mt-6 font-raleway">
        {config.title(current, max)}
      </h1>

      {/* Описание */}
      <p className="text-[16px] font-normal mt-3 text-white/80 font-raleway">
        Новые будут доступны через:
      </p>

      {/* Таймер */}
      <div className="mt-3 rounded-[8px] bg-[#0B6666] px-4 py-2 text-[16px] font-medium">
        {timeLeft}
      </div>

      {/* Кнопка */}
      <button
        className="mt-8 w-[343px] h-[52px] bg-[#A1F69E] text-[#010D0D] rounded-[400px] font-semibold text-[16px] font-raleway hover:bg-[#8fe48c] transition-colors"
        onClick={handleUpgradeClick}
      >
        {config.buttonText}
      </button>
    </div>
  );
}

export default DayLimit;
